import { Link } from 'react-router';

/**
 * "← Zurück" as a real button (T-41, mockups): a bordered white button with an arrow, the same on
 * every page that leads one level up.
 */
export function BackButton({ to, children }: { to: string; children: string }) {
  return (
    <Link
      to={to}
      className="inline-flex min-h-11 items-center gap-2 self-start rounded-lg border border-slate-300 bg-white px-4 py-2 font-semibold text-slate-900 no-underline shadow-sm hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-blue-700"
      >
        <path d="M10 3 5 8l5 5" />
      </svg>
      {children}
    </Link>
  );
}
